import { SheepIcon } from './SheepIcon';

/**
 * author: Michael Irigoyen
 * id DEA01DF4-6FBD-45B7-AC58-CBF70545FBBA
 * name sheep
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sheep.svg
 * tags
 * - Animal 
 * - Agriculture 
 */
export const EmojiSheepIcon = SheepIcon;
export default EmojiSheepIcon